import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { STORES_ROUTE } from '../shared/constants/routes';
import { StoresComponent } from './stores/stores.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
  {
    path: STORES_ROUTE,
    component: StoresComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StoresRoutingModule {}
